import { LAYOUTS, POSITION, } from '@voltmoney/types';
import { AmountCardTypeTokens, AspectRatioToken, BorderRadiusTokens, ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconTokens, ImageSizeTokens, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackSelfContent, StackType, StackWidth, WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import { ACTION } from './types';
import { copyToClipboard, goBack, goToPaymentPage, leadToPayment, navToInfo, needHelp, repayment } from './actions';
import { api } from '../../../configs/api';
import { getAppHeader, initializeFirebase } from '../../../configs/config';
import { getBankPNGUrl, getCreditData, getForeClosureDetails, getUserContext, mockCurrentDate, removeUrlWithoutReload } from '../../../configs/utils';
import _ from 'lodash';
import { LOAN_RENEWAL_FLOW_SHOW, QUERY_PARAMS, TARGET_PAGES } from '../../../configs/constants';
import { showBankDetails } from "./utils";
import { Platform } from "react-native";
import AsyncStorage from '@react-native-async-storage/async-storage';
import sharedPropsService from "../../../SharedPropsService";
import SharedPropsService from "../../../SharedPropsService";
import moment from "moment";
export const template = (userName, principalLoanAmount, bankAccountNumber, bankIfscCode, bankName, bankCode, beneficiaryName, branchName, interestBankName, interestBankCode, interestAccountNumber, interestBeneficiaryName, interestAmount, interestIfscCode, interestBranchName, outStandingAmount, hasWithdrawn, lenderAccountId, isLoanExpired) => ({
    layout: {
        id: ROUTE.REPAYMENT,
        type: LAYOUTS.LIST,
        widgets: [
            Platform.OS === "ios" ? { id: "spaceXXL", type: WIDGET.SPACE, position: POSITION.ABSOLUTE_TOP } : {},
            { id: 'repaymentReference_DO_NOT_REMOVE', type: WIDGET.SPACE },
            {
                id: 'customHeader',
                type: WIDGET.CUSTOM_HEADER,
                position: POSITION.ABSOLUTE_TOP,
            },
            hasWithdrawn ? { id: 'noAmountToPayCard', type: WIDGET.STACK } : {},
            // { id: "space0", type: WIDGET.SPACE },
            { id: 'amountItem', type: WIDGET.AMOUNTCARD },
            { id: 'headSpace', type: WIDGET.SPACE },
            showBankDetails(lenderAccountId) ? { id: 'headStack', type: WIDGET.TEXT } : {},
            { id: 'space0', type: WIDGET.SPACE },
            { id: 'makeOnlinePayment', type: WIDGET.BUTTON },
            { id: 'bankTransferRepayment', type: WIDGET.REPAYMENT_BANK_TRANSFER },
            // showBankDetails(lenderAccountId) ? { id: 'headStack', type: WIDGET.TEXT } : {},
            // showBankDetails(lenderAccountId) ? { id: 'headSpace', type: WIDGET.SPACE } : {},
            // showBankDetails(lenderAccountId) ? { id: 'messageStack', type: WIDGET.TEXT } : {},
            // showBankDetails(lenderAccountId) ? { id: 'messageSpace', type: WIDGET.SPACE } : {},
            // showBankDetails(lenderAccountId) ? {
            //     id: 'bankStack',
            //     type: WIDGET.STACK,
            // } : {},
            // showBankDetails(lenderAccountId) ? { id: 'dividerTopSpace', type: WIDGET.SPACE } : {},
            // showBankDetails(lenderAccountId) ? { id: 'divider', type: WIDGET.DIVIDER } : {},
            // showBankDetails(lenderAccountId) ? {
            //     id: 'listItem1',
            //     type: WIDGET.LIST_ITEM,
            // } : {},
            // showBankDetails(lenderAccountId) ? {
            //     id: 'listItem2',
            //     type: WIDGET.LIST_ITEM,
            // } : {},
            // showBankDetails(lenderAccountId) ? {
            //     id: 'listItem3',
            //     type: WIDGET.LIST_ITEM,
            // } : {},
            // showBankDetails(lenderAccountId) ? {
            //     id: 'listItem4',
            //     type: WIDGET.LIST_ITEM,
            // } : {},
            // showBankDetails(lenderAccountId) ? { id: 'listSpace', type: WIDGET.SPACE } : {},
        ],
    },
    datastore: {
        repaymentReference_DO_NOT_REMOVE: { size: SizeTypeTokens.NONE },
        dividerTopSpace: { size: SizeTypeTokens.LG },
        customHeader: {
            title: "Flexi repay",
            goBackAction: {
                type: ACTION.GO_BACK,
                payload: {
                    value: '',
                    isResend: false,
                    id: "btn_repayment_goBack"
                },
                routeId: ROUTE.REPAYMENT,
            },
            needHelpAction: {
                type: ACTION.NEED_HELP,
                routeId: ROUTE.REPAYMENT,
                payload: {
                    id: "btn_repayment_needHelp"
                }
            }
        },
        spaceXXL: {
            size: SizeTypeTokens.XXL
        },
        space0: { size: SizeTypeTokens.XL },
        amountItem: {
            title: 'Outstanding amount',
            subTitle: principalLoanAmount === null
                ? '0'
                : `${principalLoanAmount}`.replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ','),
            subscriptTitle: '',
            message: isLoanExpired ? undefined : 'Enjoy flexible repayments. Pay partially or the complete amount in just one go.',
            type: AmountCardTypeTokens.MESSAGE,
            isLoanExpired: isLoanExpired,
            infoAction: {
                routeId: ROUTE.REPAYMENT,
                type: ACTION.NAV_TO_INFO,
                payload: {}
            }
        },
        noAmountToPayCard: {
            type: StackType.column,
            width: StackWidth.FULL,
            padding: {
                left: SizeTypeTokens.XL,
                right: SizeTypeTokens.XL,
                top: SizeTypeTokens.LG,
                bottom: SizeTypeTokens.LG,
            },
            borderConfig: {
                borderRadius: BorderRadiusTokens.BR1,
            },
            bgColor: ColorTokens.Yellow_10,
            widgetItems: [{ id: 'widgetText', type: WIDGET.TEXT }],
        },
        widgetText: {
            label: `There is no outstanding balance associated with your account right now. If you wish to withdraw funds, please go to the dashboard and start a withdrawal.`,
            color: ColorTokens.Grey_Night,
            fontSize: FontSizeTokens.XXS,
            fontWeight: '600',
            lineHeight: 16,
            fontFamily: FontFamilyTokens.Inter,
        },
        amountSpace: { size: SizeTypeTokens.Size32 },
        spaceXXXL: {
            size: SizeTypeTokens.XXXL,
        },
        headStack: {
            label: 'Repay via UPI, Card or Net Banking',
            fontSize: FontSizeTokens.MD,
            color: ColorTokens.Grey_Night,
            fontFamily: FontFamilyTokens.Poppins,
            lineHeight: 24,
            fontWeight: '700',
        },
        bankTransferRepayment: {
            userName,
            bankName,
            bankImage: getBankPNGUrl(bankCode),
            bankIfscCode,
            bankAccountNumber,
            beneficiaryName,
            branchName,
            interestBankName,
            interestBankImage: getBankPNGUrl(interestBankCode),
            interestAccountNumber,
            interestBeneficiaryName,
            interestAmount,
            interestIfscCode,
            interestBranchName,
            outStandingAmount
        },
        makeOnlinePayment: {
            id: 'bt_flexiRepay_onlinePayment',
            action: {
                type: isLoanExpired
                    ? ACTION.LOAN_EXPIRE_REPAYMENT
                    : ACTION.MAKE_PAYMENT,
                routeId: ROUTE.REPAYMENT,
                payload: {
                    amount: principalLoanAmount
                },
            },
            alignSelf: StackSelfContent.center,
            fontSize: FontSizeTokens.SM,
            fontWeight: '700',
            justifyContent: StackJustifyContent.center,
            label: 'Select amount',
            type: hasWithdrawn
                ? ButtonTypeTokens.LargeOutline
                : ButtonTypeTokens.LargeFilled,
            width: ButtonWidthTypeToken.FULL,
        },
        headSpace: { size: SizeTypeTokens.XS },
        messageStack: {
            label: 'To easily repay your principal via NEFT/IMPS, add this account as a beneficiary. Repayment must be from the bank account used for verification.',
            fontSize: FontSizeTokens.XS,
            color: ColorTokens.Grey_Charcoal,
            lineHeight: 18,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '400',
        },
        messageSpace: { size: SizeTypeTokens.XL },
        bankStack: {
            type: StackType.row,
            alignItems: StackAlignItems.center,
            justifyContent: StackJustifyContent.flexStart,
            widgetItems: [
                { id: 'leadItem', type: WIDGET.IMAGE },
                { id: 'space', type: WIDGET.SPACE },
                { id: 'data', type: WIDGET.TEXT },
            ],
        },
        leadItem: {
            uri: getBankPNGUrl(bankCode),
            size: ImageSizeTokens.SM,
            aspectRatio: AspectRatioToken.A1_1,
            borderRadius: BorderRadiusTokens.BR5,
            padding: SizeTypeTokens.SM,
        },
        space: { size: SizeTypeTokens.SM },
        data: {
            label: `${bankName}`,
            fontSize: FontSizeTokens.MD,
            lineHeight: 24,
            color: ColorTokens.Grey_Night,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '700',
        },
        divider: {
            color: ColorTokens.Grey_Milk_1,
        },
        listItem1: {
            id: `txt_flexiRepay${bankIfscCode}`,
            title: 'IFSC',
            subTitle: `${bankIfscCode}`,
            trailLabel: {
                label: 'Copy',
                fontSize: FontSizeTokens.XS,
                color: ColorTokens.Primary_100,
                fontFamily: FontFamilyTokens.Inter,
                lineHeight: 18,
                fontWeight: '500',
            },
            trailIconName: IconTokens.Copy,
            isDivider: true,
            action: {
                type: ACTION.COPY,
                routeId: ROUTE.REPAYMENT,
                payload: { value: `${bankIfscCode}`, widgetId: 'listItem1' },
            },
        },
        listItem2: {
            id: `txt_flexiRepay${bankIfscCode}`,
            title: 'Account number',
            subTitle: `${bankAccountNumber}`,
            trailLabel: {
                label: 'Copy',
                fontSize: FontSizeTokens.XS,
                color: ColorTokens.Primary_100,
                fontFamily: FontFamilyTokens.Inter,
                lineHeight: 18,
                fontWeight: '500',
            },
            trailIconName: IconTokens.Copy,
            isDivider: true,
            action: {
                type: ACTION.COPY,
                routeId: ROUTE.REPAYMENT,
                payload: {
                    value: `${bankAccountNumber}`,
                    widgetId: 'listItem2'
                },
            },
        },
        listItem3: {
            id: `txt_flexiRepay${bankIfscCode}`,
            title: 'Beneficiary name',
            subTitle: `${beneficiaryName}`,
            trailLabel: {
                label: 'Copy',
                fontSize: FontSizeTokens.XS,
                color: ColorTokens.Primary_100,
                fontFamily: FontFamilyTokens.Inter,
                lineHeight: 18,
                fontWeight: '500',
            },
            trailIconName: IconTokens.Copy,
            isDivider: true,
            action: {
                type: ACTION.COPY,
                routeId: ROUTE.REPAYMENT,
                payload: {
                    value: `${beneficiaryName}`,
                    widgetId: 'listItem3'
                },
            },
        },
        listItem4: {
            id: `txt_flexiRepay${bankIfscCode}`,
            title: 'Branch name',
            subTitle: `${branchName}`,
            trailLabel: {
                label: 'Copy',
                fontSize: FontSizeTokens.XS,
                color: ColorTokens.Primary_100,
                fontFamily: FontFamilyTokens.Inter,
                lineHeight: 18,
                fontWeight: '500',
            },
            trailIconName: IconTokens.Copy,
            action: {
                type: ACTION.COPY,
                routeId: ROUTE.REPAYMENT,
                payload: { value: `${branchName}`, widgetId: 'listItem4' },
            },
        },
        listSpace: { size: SizeTypeTokens.XXXXXL },
        keyboardSpace: { size: SizeTypeTokens.XXXXXXL },
        keyboardSpace2: { size: SizeTypeTokens.XXXXXXL },
        keyboardSpace3: { size: SizeTypeTokens.XXXXXXL },
    },
});
export const repaymentMF = {
    onLoad: async ({ instrumentTrack, network }, { target }) => {
        instrumentTrack('REPAYMENT_PAGE_VIEWED');
        await initializeFirebase();
        await sharedPropsService.setIsLoanRenewalRepaymentActive(false);
        // const userContextResponse = await network.post(
        //     api.userContext,
        //     {},
        //     { headers: await getAppHeader() },
        // )
        // await sharedPropsService.setUser(userContextResponse?.data);
        let userContextResponse = await getUserContext(network);
        userContextResponse.data = userContextResponse;
        const userName = userContextResponse.data.user.fullName;
        //call credit api to check if the loan have expired
        let principalLoanAmount = userContextResponse.data.linkedCredits[0].principalOutStandingAmount;
        let hasWithdrawn = principalLoanAmount === null || principalLoanAmount === 0;
        const response = await network.get(`${api.repaymentBankAccountDetails}${userContextResponse.data.linkedCredits[0].creditId}`, {
            headers: await getAppHeader(),
        });
        await AsyncStorage.removeItem("target");
        if (target && target === TARGET_PAGES.REPAYMENT) {
            removeUrlWithoutReload(QUERY_PARAMS.TARGET);
        }
        // -------------- LOAN EXPIRY SCENARIO ---------- //
        const creditData = await getCreditData(network);
        const config = await SharedPropsService.getFirebaseConfig();
        const loan_renewal_test_flag = config?.loan_renewal_test_flag;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        const currentMoment = (loan_renewal_test_flag === true || loan_renewal_test_flag === 'true') ? await mockCurrentDate() : moment().startOf('day').unix() * 1000;
        const renewalDate = creditData?.renewalDate;
        const isLoanExpired = (currentMoment >= renewalDate)
            || (moment(currentMoment).isSame(moment(renewalDate), 'day'));
        if (await LOAN_RENEWAL_FLOW_SHOW() && isLoanExpired === true) {
            const getForeClosureData = await getForeClosureDetails(network);
            if (getForeClosureData) {
                principalLoanAmount = getForeClosureData?.netPayable;
                hasWithdrawn = getForeClosureData?.netPayable === null
                    || getForeClosureData?.netPayable === 0
                    || getForeClosureData?.netPayable === 'null';
            }
        }
        // ---------------------------------------------- //
        const lenderAccountId = userContextResponse?.data?.linkedCredits[0]?.lendingPartnerId;
        const bankName = _.get(response, 'data.principleRepaymentBankAccountDetails.bankName', '');
        const bankCode = _.get(response, 'data.principleRepaymentBankAccountDetails.bankCode', '');
        const accountNumber = _.get(response, 'data.principleRepaymentBankAccountDetails.accountNumber', '');
        const ifscCode = _.get(response, 'data.principleRepaymentBankAccountDetails.ifscCode', '');
        const beneficiaryName = 'Bajaj Finance Ltd';
        const branchName = 'Nariman Point, Mumbai';
        let interestResponse = {
            data: {
                totalAmount: 0
            }
        };
        try {
            interestResponse = await network.get(`${api.interestDetails}${userContextResponse.data.linkedCredits[0].creditId}`, {
                headers: await getAppHeader(),
            }, null, {
                disableDefault: true
            });
        }
        catch (error) {
            console.error('Error fetching data:', error);
            interestResponse = {
                data: {
                    totalAmount: 0
                }
            };
        }
        const interestBankName = _.get(response, 'data.interestRepaymentBankAccountDetails.bankName', '');
        const interestBankCode = _.get(response, 'data.interestRepaymentBankAccountDetails.bankCode', '');
        const interestAccountNumber = _.get(response, 'data.interestRepaymentBankAccountDetails.accountNumber', '');
        const interestIfscCode = _.get(response, 'data.interestRepaymentBankAccountDetails.ifscCode', '');
        const interestBeneficiaryName = 'Bajaj Finance Ltd';
        const interestBranchName = 'Nariman Point, Mumbai';
        const interestAmount = _.get(interestResponse, 'data.totalAmount', '') || 0;
        const outStandingAmount = creditData?.principalOutStandingAmount;
        return Promise.resolve(template(userName, principalLoanAmount, accountNumber, ifscCode, bankName, bankCode, beneficiaryName, branchName, interestBankName, interestBankCode, interestAccountNumber, interestBeneficiaryName, interestAmount, interestIfscCode, interestBranchName, outStandingAmount, hasWithdrawn, lenderAccountId, isLoanExpired));
    },
    actions: {
        [ACTION.REPAYMENT]: repayment,
        [ACTION.LOAN_EXPIRE_REPAYMENT]: leadToPayment,
        [ACTION.GO_BACK]: goBack,
        [ACTION.COPY]: copyToClipboard,
        [ACTION.MAKE_PAYMENT]: goToPaymentPage,
        [ACTION.NEED_HELP]: needHelp,
        [ACTION.NAV_TO_INFO]: navToInfo,
    },
    clearPrevious: true,
};
